import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface LienPictoProps extends pictoProps {
}

export interface LienPictoState extends pictoState {
}

export class LienPicto extends Picto<LienPictoProps,LienPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.lienPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(LienPicto);
